// extracted by mini-css-extract-plugin
export default {"container":"Mf","header":"Nf","logodesktop":"Of","logomobile":"Pf","imgcontainer":"Qf","slidercontainer":"Rf","slick-slider":"Sf","slick-initialized":"Tf","sliderbox":"Uf","headline":"Vf","mainheadline":"Wf","capitalize":"Xf","desc":"Yf","descitalic":"Zf","desccenter":"ag","descborder":"bg","subdesc":"cg","welcomeslide":"eg","desccard":"fg","img":"gg","button":"hg","buttonskip":"ig","customPosition":"jg"};
    if(module.hot) {
      // 1715276858220
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  